// import moment from 'moment-timezone';
import expensesApi from '@/api/expenses';
import tagApi from '@/api/tag';
import products from '@/api/products';
import statisticApi from '@/api/statistic';
// import { formatDate, groupBy } from '../../lib/helper';

// product
const SET_PRODUCTS = 'SET_PRODUCTS';
const SET_IS_FETCHING_PRODUCTS = 'SET_IS_FETCHING_PRODUCTS';

// expense
const SET_EXPENSES = 'SET_EXPENSES';
const SET_IS_FETCHING = 'SET_IS_FETCHING';
const SET_IS_FETCHED = 'SET_IS_FETCHED';
const CLEAR_EXPENSES = 'CLEAR_EXPENSES';
const RESET_EXPENSES = 'RESET_EXPENSES';
const EDIT_EXPENSES = 'EDIT_EXPENSES';
const DELETE_EXPENSES = 'DELETE_EXPENSES';
const APPEND_EXPENSES = 'APPEND_EXPENSES';
const APPEND_NEW_EXPENSES = 'APPEND_NEW_EXPENSES';
const SET_PAGE = 'SET_PAGE';
const ADD_PAGE = 'ADD_PAGE';
const SET_IS_ALL = 'SET_IS_ALL';
const SET_EXPENSES_DETAIL = 'SET_EXPENSES_DETAIL';
const UPDATED_EXPENSES_DATA = 'UPDATED_EXPENSES_DATA';
const UPDATED_EXPENSE_TAG = 'UPDATED_EXPENSE_TAG';
const UPDATED_EXPENSE_TAGS = 'UPDATED_EXPENSE_TAGS';

// tag
const SET_TAGS = 'SET_TAGS';
const APPEND_TAGS = 'APPEND_TAGS';


// source
const SET_EXPENSE_SOURCE = 'SET_EXPENSE_SOURCE';
const SET_IS_FETCHING_SOURCE = 'SET_IS_FETCHING_SOURCE';
const CLEAR_EXPENSE_SOURCE = 'CLEAR_EXPENSE_SOURCE';
const RESET_EXPENSE_SOURCE = 'RESET_EXPENSE_SOURCE';
const EDIT_EXPENSE_SOURCE = 'EDIT_EXPENSE_SOURCE';
const DELETE_EXPENSE_SOURCE = 'DELETE_EXPENSE_SOURCE';
const APPEND_EXPENSE_SOURCE = 'APPEND_EXPENSE_SOURCE';
const APPEND_NEW_EXPENSE_SOURCE = 'APPEND_NEW_EXPENSE_SOURCE';
const SET_PAGE_SOURCE = 'SET_PAGE_SOURCE';
const ADD_PAGE_SOURCE = 'ADD_PAGE_SOURCE';
const SET_IS_ALL_SOURCE = 'SET_IS_ALL_SOURCE';
const UPDATED_EXPENSE_SOURCE_DATA = 'UPDATED_EXPENSE_SOURCE_DATA';
// const UPDATED_EXPENSE_ACTIVE_STATUS = 'UPDATED_EXPENSE_ACTIVE_STATUS';
// const SET_EXPENSE_SOURCE_DETAIL = 'SET_EXPENSE_SOURCE_DETAIL';

// statistic
const SET_EXPENSE_STAT = 'SET_EXPENSE_STAT';

const state = {
	products: [],
	isFetchingProducts: false,
	all: [],
	isFetching: false,
	isFetched: false,
	isAll: false,
	page: 1,
	detail: '',
	tags: [],
	sourceAll: [],
	isFetchingSource: false,
	isSourceAll: false,
	pageSource: 1,
	expenseStat: {},
};

const getters = {
	products: state => state.products,
	isFetchingProducts: state => state.isFetchingProducts,
	all: state => state.all,
	isFetching: state => state.isFetching,
	isFetched: state => state.isFetched,
	isAll: state => state.isAll,
	page: state => state.page,
	detail: state => state.detail,
	tags: state => state.tags,
	sourceAll: state => state.sourceAll,
	isFetchingSource: state => state.isFetchingSource,
	isSourceAll: state => state.isSourceAll,
	pageSource: state => state.pageSource,
	expenseStat: state => state.expenseStat,
};

const mutations = {
	[SET_EXPENSES](state, value) {
		state.all = value;
	},
	[APPEND_EXPENSES](state, value) {
		state.all = state.all.concat(value);
	},
	[APPEND_NEW_EXPENSES](state, value) {
		const expenses = state.all;
		expenses.unshift(value.expense);
		state.all = expenses;
	},
	[CLEAR_EXPENSES](state) {
		state.all = [];
	},
	[RESET_EXPENSES](state) {
		state.all = [];
		state.isAll = false;
		state.page = 1;
	},
	[UPDATED_EXPENSES_DATA](state, expense) {
		const expenseIndex = state.all.findIndex(curr => curr._id === expense._id);
		if (expenseIndex !== -1) {
			// state.all[expenseIndex].name = expense.name;
			// state.all[expenseIndex].amount = expense.amount;
			// state.all[expenseIndex].tags = expense.tags;
			// state.all[expenseIndex].date = expense.date;
			state.all[expenseIndex] = expense;
		}
	},
	[UPDATED_EXPENSE_TAG](state, expense) {
		const expenseIndex = state.all.findIndex(curr => curr._id === expense._id);
		if (expenseIndex !== -1) {
			state.all[expenseIndex].tags = expense.tags;
		}
	},
	[UPDATED_EXPENSE_TAGS](state, data) {
		const ids = data.ids;
		const tags = data.tags;
		for (let index = 0; index < ids.length; index++) {
			const id = ids[index];
			const expenseIndex = state.all.findIndex(curr => curr._id === id);
			if (expenseIndex !== -1) {
				state.all[expenseIndex].tags = tags;
			}
		}
	},
	[SET_IS_FETCHING](state, status) {
		state.isFetching = status;
	},
	[SET_IS_FETCHED](state, status) {
		state.isFetched = status;
	},
	[DELETE_EXPENSES](state, index) {
		state.all.splice(index, 1);
	},
	[SET_PAGE](state, page) {
		state.page = page;
	},
	[ADD_PAGE](state) {
		state.page++;
	},
	[SET_IS_ALL](state, isAll) {
		state.isAll = isAll;
	},
	[EDIT_EXPENSES](state, expenses) {
		const index = state.all.findIndex(el => el._id === expenses._id);
		if (index !== -1) {
			state.all[index] = expenses;
		}
	},
	[SET_EXPENSES_DETAIL](state, value) {
		state.detail = value;
	},

	// tgs
	[SET_TAGS](state, tags) {
		state.tags = tags;
	},
	[APPEND_TAGS](state, tags) {
		state.tags = state.tags.concat(tags);
	},

	// products
	[SET_IS_FETCHING_PRODUCTS](state, value) {
		state.isFetchingProducts = value;
	},
	[SET_PRODUCTS](state, products) {
		// const empty = { _id: 0, name: '' };
		// products.unshift(empty);
		state.products = products;
	},

	// statistic
	[SET_EXPENSE_STAT](state, value) {
		state.expenseStat = value;
	},

	// expense source
	[SET_EXPENSE_SOURCE](state, value) {
		state.sourceAll = value;
	},
	[APPEND_EXPENSE_SOURCE](state, value) {
		state.sourceAll = state.sourceAll.concat(value);
	},
	[APPEND_NEW_EXPENSE_SOURCE](state, value) {
		const expenses = state.sourceAll;
		expenses.unshift(value.source);
		state.sourceAll = expenses;
	},
	[CLEAR_EXPENSE_SOURCE](state) {
		state.sourceAll = [];
	},
	[RESET_EXPENSE_SOURCE](state) {
		state.sourceAll = [];
		state.isSourceAll = false;
		state.pageSource = 1;
	},
	[UPDATED_EXPENSE_SOURCE_DATA](state, expense) {
		const expenseIndex = state.sourceAll.findIndex(curr => curr._id === expense._id);
		if (expenseIndex !== -1) {
			state.sourceAll[expenseIndex].name = expense.name;
			state.sourceAll[expenseIndex].data = expense.data;
			state.sourceAll[expenseIndex].product_id = expense.product_id;
			state.sourceAll[expenseIndex].is_active = expense.is_active;
			state.sourceAll[expenseIndex].tax_ppn = expense.tax_ppn;
		}
	},
	[SET_IS_FETCHING_SOURCE](state, status) {
		state.isFetchingSource = status;
	},
	[DELETE_EXPENSE_SOURCE](state, index) {
		state.sourceAll.splice(index, 1);
	},
	[SET_PAGE_SOURCE](state, page) {
		state.pageSource = page;
	},
	[ADD_PAGE_SOURCE](state) {
		state.pageSource++;
	},
	[SET_IS_ALL_SOURCE](state, isSourceAll) {
		state.isSourceAll = isSourceAll;
	},
	[EDIT_EXPENSE_SOURCE](state, expenses) {
		const index = state.sourceAll.findIndex(el => el._id === expenses._id);
		if (index !== -1) {
			state.sourceAll[index] = expenses;
		}
	},

};

const actions = {
	// eslint-disable-next-line
	// get product
	getProducts({ commit, getters }) {
		if (!getters.isFetchingProducts) {
			commit(SET_IS_FETCHING_PRODUCTS, true);
			const callback = (response) => {
				const products = response.data;
				commit(SET_PRODUCTS, products);
				commit(SET_IS_FETCHING_PRODUCTS, false);
			};
			const errorCallback = (e) => {
				// eslint-disable-next-line
				console.log(e);
				commit(SET_IS_FETCHING_PRODUCTS, false);
			};
			// products.getProductsList(callback, errorCallback);
			products.getProductsList(callback, errorCallback);
		}
	},
	// expenses
	getExpenses({ commit, getters }, params) {
		if (!getters.isFetching) {
			commit(SET_IS_FETCHING, true);
			const callback = (response) => {
				const expenses = response.data;
				if (expenses.length !== 0) {
					commit(APPEND_EXPENSES, expenses);
					commit(ADD_PAGE);
				} else {
					commit(SET_IS_ALL, true);
				}
				commit(SET_IS_FETCHING, false);
				commit(SET_IS_FETCHED, true);
			};
			const errorCallback = (e) => {
				// eslint-disable-next-line
				console.log(e);
				commit(SET_IS_FETCHING, false);
				commit(SET_IS_ALL, true);
				commit(SET_IS_FETCHED, true);
			};
			expensesApi.getExpenses(params, callback, errorCallback);
		}
	},
	getDetailExpenses({ commit }, params) {
		commit(SET_IS_FETCHING, true);
		const callback = (response) => {
			const expenses = response.data;
			commit(SET_EXPENSES_DETAIL, expenses);
			commit(SET_IS_FETCHING, false);
		};
		const errorCallback = (e) => {
			// eslint-disable-next-line
			console.log(e);
			commit(SET_IS_FETCHING, false);
		};
		expensesApi.getDetails(params, callback, errorCallback);
	},
	delete({ commit }, index) {
		commit(DELETE_EXPENSES, index);
	},
	setPage({ commit }, value) {
		commit(SET_PAGE, value);
	},
	setIsAll({ commit }, isAll) {
		commit(SET_IS_ALL, isAll);
	},
	clearExpenses({ commit }) {
		commit(CLEAR_EXPENSES);
	},
	resetExpenses({ commit }) {
		commit(RESET_EXPENSES);
	},
	updateExpenses({ commit }, contact) {
		commit(EDIT_EXPENSES, contact);
	},
	setAppendExpenses({ commit }, value) {
		commit(SET_EXPENSES, value);
	},
	setAppendNewExpenses({ commit }, value) {
		commit(APPEND_NEW_EXPENSES, value);
	},
	updatedExpensesData({ commit }, value) {
		commit(UPDATED_EXPENSES_DATA, value);
	},
	updatedExpenseTag({ commit }, value) {
		commit(UPDATED_EXPENSE_TAG, value);
	},
	updatedExpenseTags({ commit }, value) {
		commit(UPDATED_EXPENSE_TAGS, value);
	},

	// tags
	getExpensesTags({ commit }, params) {
		const callback = (response) => {
			const tags = response.data;
			if (tags.length !== 0) {
				commit(SET_TAGS, tags);
			}
		};
		const errorCallback = (e) => {
			// eslint-disable-next-line
			console.log(e);
		};
		tagApi.getTags(params, callback, errorCallback);
	},
	setAppendTag({ commit }, value) {
		commit(APPEND_TAGS, value);
	},

	// source
	getExpenseSource({ commit, getters }, params) {
		if (!getters.isFetchingSource) {
			commit(SET_IS_FETCHING_SOURCE, true);
			const callback = (response) => {
				const sources = response.data;
				if (sources.length !== 0) {
					commit(APPEND_EXPENSE_SOURCE, sources);
					commit(ADD_PAGE_SOURCE);
				} else {
					commit(SET_IS_ALL_SOURCE, true);
				}
				commit(SET_IS_FETCHING_SOURCE, false);
				commit(SET_IS_FETCHED, true);
			};
			const errorCallback = (e) => {
				// eslint-disable-next-line
				console.log(e);
				commit(SET_IS_FETCHING_SOURCE, false);
				commit(SET_IS_ALL_SOURCE, true);
				commit(SET_IS_FETCHED, true);
			};
			expensesApi.getExpenseSource(params, callback, errorCallback);
		}
	},
	setExpenseSourceIsFetch({ commit }, value) {
		commit(SET_IS_FETCHING_SOURCE, value);
	},
	deleteExpenseSource({ commit }, index) {
		commit(DELETE_EXPENSE_SOURCE, index);
	},
	setPageExpenseSource({ commit }, value) {
		commit(SET_PAGE_SOURCE, value);
	},
	setIsAllExpenseSource({ commit }, isAllSource) {
		commit(SET_IS_ALL_SOURCE, isAllSource);
	},
	clearExpenseSource({ commit }) {
		commit(CLEAR_EXPENSE_SOURCE);
	},
	resetExpenseSource({ commit }) {
		commit(RESET_EXPENSE_SOURCE);
	},
	updateExpenseSource({ commit }, value) {
		commit(EDIT_EXPENSE_SOURCE, value);
	},
	setAppendExpenseSource({ commit }, value) {
		commit(SET_EXPENSE_SOURCE, value);
	},
	setAppendNewExpenseSource({ commit }, value) {
		commit(APPEND_NEW_EXPENSE_SOURCE, value);
	},
	updatedExpenseSourceData({ commit }, value) {
		commit(UPDATED_EXPENSE_SOURCE_DATA, value);
	},

	// statistic
	getStatistic({ commit }, params) {
		commit(SET_IS_FETCHING, true);
		const callback = (response) => {
			const stats = response.data;
			commit(SET_EXPENSE_STAT, stats);
			commit(SET_IS_FETCHING, false);
		};
		const errorCallback = (e) => {
			// eslint-disable-next-line
			console.log(e);
			commit(SET_IS_FETCHING, false);
		};
		statisticApi.getExpenseStats(params, callback, errorCallback);
	},

};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
